import React, { PureComponent } from 'react';
import { Input as InputAnt } from 'antd';
import PropTypes from 'prop-types';

const { TextArea, Group } = InputAnt;

export default class Input extends PureComponent {
  render() {
    if (this.props.type === 'textArea') {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return (<TextArea {...this.props} />);
    }
    if (this.props.type === 'inputGroup') {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return (<Group {...this.props} />);
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (<InputAnt {...this.props} />);
  }
}

Input.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

Input.defaultProps = {
  type: ''
};
